import { useContext } from 'react';
import { Breadcrumbs } from '@ascd/witsby-components';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import { ADMIN_ROUTES } from '@constants';
import { eDashboardActionType, DashboardContext } from '@contexts/dashboardContext';

const AdminDashboardBreadCrumbs = () => {
  const {
    dispatch,
    state: { detailsPage },
  } = useContext(DashboardContext);

  const detailsTitle = startCase(get(detailsPage, 'type', '')?.toLowerCase());

  let topLearningsTitle = get(
    detailsPage,
    'detailsPageData.selectedLearning',
    'Learnings',
  ).toLowerCase();
  if (topLearningsTitle === 'strategy') {
    topLearningsTitle = 'Strategies';
  }

  return (
    <Breadcrumbs
      routeList={[
        {
          icon: 'DASHBOARD',
          routeName: 'Dashboard',
          pathName: ADMIN_ROUTES.ADMIN,
        },
        /* Details */
        // Top Learnings
        ...(detailsPage !== null && detailsTitle === 'Top Learnings'
          ? [
              {
                routeName: `Top ${startCase(topLearningsTitle)}`,
              },
            ]
          : []),
        // Highest Rated
        ...(detailsPage !== null && detailsTitle === 'Highest Rated'
          ? [
              {
                routeName: `Highest Rated ${startCase(topLearningsTitle)}`,
              },
            ]
          : []),
        // Other Details
        ...(detailsPage !== null &&
        detailsTitle !== 'Top Learnings' &&
        detailsTitle !== 'Highest Rated'
          ? [{ routeName: detailsTitle }]
          : []),
      ]}
      onClick={() => {
        dispatch({
          data: null,
          type: 'DETAILS_PAGE' as eDashboardActionType.DETAILS_PAGE,
        });
      }}
    />
  );
};

export default AdminDashboardBreadCrumbs;
